import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/styles';
import { Router } from 'react-router-dom';
import { ThemeModel } from '../../models';
import ConfiguredRoutes from '../ConfiguredRoutes';
import Favicon from 'components/Favicon';
import history from 'utils/history';
import ScrollToTop from 'utils/ScrollToTop';
import merge from 'utils/merge.util';
import ErrorHandler from 'domains/core/error/components/ErrorHandler';
import { useInitSession } from 'domains/core/session/hooks';
import LocalesProvider from 'domains/core/locales/components/LocalesProvider';
import NotificationProvider from 'domains/core/notification/components/NotificationProvider';
import NotificationHandler from 'domains/core/notification/components/NotificationHandler';

const renderContent = (favicon, routesConfig) => {
  return (
    <>
      {favicon && <Favicon {...favicon} />}
      <LocalesProvider>
        <NotificationProvider maxSnackbars={10}>
          <ErrorHandler>
            <Router history={history}>
              <ScrollToTop>
                <ConfiguredRoutes {...routesConfig} />
              </ScrollToTop>
            </Router>
          </ErrorHandler>
          <NotificationHandler />
        </NotificationProvider>
      </LocalesProvider>
    </>
  );
};

const Main = ({ theme, favicon, ...routesConfig }) => {
  useInitSession();
  return theme ? (
    <ThemeProvider theme={outerTheme => merge(outerTheme, theme)}>
      {renderContent(favicon, routesConfig)}
    </ThemeProvider>
  ) : (
    renderContent(favicon, routesConfig)
  );
};

Main.propTypes = {
  routes: PropTypes.object.isRequired,
  unrecoverable: PropTypes.func.isRequired,
  favicon: PropTypes.object,
  theme: ThemeModel,
};

Main.defaultProps = {
  favicon: undefined,
  theme: undefined,
  routes: [],
};

export default Main;
